module.exports = __webpack_public_path__ + "media/images/font/flaticon-7d05b7f9d20ecd41fd5fe85e65661103.svg";